export default __webpack_public_path__ + "static/media/delete.e4efcb06.svg";